import type { TradingSessionDurationMinutes } from '@/lib/api/tradingSession';

/**
 * The window a Connected Wallet sign-in opens without asking. The user is
 * never shown a duration picker on that path; the full dialog (expiry
 * banner, job reauthorization) still offers 5/15/30/60 and defaults here.
 */
export const DEFAULT_TRADING_WINDOW_MINUTES: TradingSessionDurationMinutes = 30;
